import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import OrgCard from '../../components/OrgCard'
import { useNavigate, useParams } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FaPlus } from 'react-icons/fa'

const UserOrgs = () => {
    const [organizations, setOrganizations] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    const navigate = useNavigate()
     const { user } = useParams()

    const getUserOrgs = async (currentPage) => {
        try {
            setIsLoading(true)
            const response = await api.get(`/users/${user}/organizations?page=${currentPage}`)
            // console.log(response)
            const newData = response.data.organizations.member || []

            setOrganizations(prev => [...prev, ...newData])
            setHasMore(newData.length > 0) // Stop when no more data is returned
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setHasMore(false)
            toast.error(error?.response?.data?.message || 'Failed to fetch organizations')
        }
        finally{
          setIsLoading(false)
        }
    }

    useEffect(() => {
        getUserOrgs(page)
    }, [page])

    return (
        <div className='orgpage-body'>
            <div className="orglist-page-header">
                <h2 className='page-title'>Organizations</h2>
                <button className='centered-content' onClick={() => navigate("/organizations/suggested")}>
                    <FaPlus />
                </button>
            </div>
            <div className="org-list-container">
                {organizations.length === 0 && !isLoading && (
                    <p className="not-found-msg">No organizations found</p>
                )}
                <InfiniteScroll
                    dataLength={organizations.length}
                    next={() => setPage(prev => prev + 1)}
                    hasMore={hasMore}
                    loader={<Loader />}
                >
                    {
                        organizations.map((org) => (
                            <OrgCard org={org} key={org._id} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default UserOrgs
